"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _proptypes = require("../../services/proptypes");

var _Image = _interopRequireDefault(require("./components/Image"));

var _Color = _interopRequireDefault(require("./components/Color"));

require("./Background.css");

var propTypes = {
  children: _proptypes.ChildrenPropType.isRequired
};

function Background(_ref) {
  var children = _ref.children,
      gridProps = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, gridProps, children);
}

Background.propTypes = propTypes;
Background.Image = _Image["default"];
Background.Color = _Color["default"];
var _default = Background;
exports["default"] = _default;